<svg aria-hidden="true" [attr.color]="color" [class]="size ? size : 'default'" xmlns="http://www.w3.org/2000/svg">
  <use [attr.xlink:href]="link" [attr.href]="link" />
</svg>
